export default __webpack_public_path__ + "static/media/45.21856bf4.jpg";